module.exports = __webpack_public_path__ + "static/media/profile_pic.442c3075.jpg";